/**
 *
 * @author Patrik Harag
 * @version 2026-09-01
 */
export default class NotImplementedError extends Error {

    constructor() {
        super('Method is not implemented');
        this.name = 'NotImplementedError';
    }
}
